import React, {Component} from 'react';
import axios from 'axios';
import {FaCircle, FaDatabase, FaServer} from "react-icons/fa";
import { connect } from 'react-redux';
import {Alert, Input, Label} from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import {Link} from "react-router-dom";
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ModalComponent from "../../ModalComponent";
import LoginToImg from '../../../assets/img/cpanel/login_to_cpanel.png';
import UpgradeImg from '../../../assets/img/cpanel/upgrade.png';
import ChangePassImg from '../../../assets/img/cpanel/passwd.png';
import ChangeDomainImg from '../../../assets/img/cpanel/domain.png';
import FileManageImg from '../../../assets/img/cpanel/file_manager.png';
import SqlImg from '../../../assets/img/cpanel/mysql_databases.png';
import BackupImg from '../../../assets/img/cpanel/backup.png';
import SubDomainImg from '../../../assets/img/cpanel/subdomains.png';
import CronJobImg from '../../../assets/img/cpanel/cron_jobs.png';
import PhpMyAdminImg from '../../../assets/img/cpanel/php_my_admin.png';
import AwstatsImg from '../../../assets/img/cpanel/awstats.png';
import AddonDomain from '../../../assets/img/cpanel/addon_domains.png';

class DetailHostingComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            hosting: {},
            isNotification: false,
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            changeDomain: '',
            changePassword: '',
            strengPass: 0,
            errorNotification: '',
            messageErrorNotification: '',
        }
    }

    componentDidMount() {
        // this.props.updateUrlRedirect({ url: window.location.href })
        window.scrollTo(0, 0);
        this.getDetailHosting(this.props.hostingId);

        this.setState({
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
        })
        // console.log(this.props.errorNotificationUser);
        // console.log(this.props.successNotificationUser);
        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
    }

    getDetailHosting = (hostingId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/hosting/getDetailHosting/' + hostingId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        hosting: ref.data.hosting,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn đặt hàng thất bại',
                })
            })
    }

    redirectBack = (message, orderId) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectBack();
    }

    actionHosting = (type) => {
        if ( type === 'change_password' || type === 'change_domain' ) {
            this.showModal(type);
        }
        else {
            this.confirmHosting();
        }
    }

    showModal = (action) => {
        let titleModal;
        let modalBody;
        if ( action === 'change_password' ) {
            titleModal = 'Đổi mật khẩu';
            modalBody = this.modalBody(action);
        }
        else if ( action === 'change_domain' ) {
            titleModal = 'Đổi Domain';
            modalBody = this.modalBody(action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
        })
    }

    modalBody = (action) => {
        if ( action === 'change_password' ) {
            return (
                <>
                    <div className="form-group">
                        <Label for={'Password'}>{'Password'}</Label>
                        <Input type="text" className="form-control" placeholder="Password" name="password" onChange={this.changePassword} value={this.state.password} />
                    </div>
                    <div className="progress mt-1" id="passwordStrengthBar">
                        {
                            this.state.strengPass > 75 ? (
                                <div className="progress-bar progress-bar-success" role="progressbar"
                                     aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                     style={{ width: `${this.state.strengPass}%`}}
                                >
                                    <span className="progress-text color-white text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                </div>
                            ) : (
                                <div
                                    className="progress-bar progress-bar-danger" role="progressbar"
                                    aria-valuenow={ this.state.strengPass } aria-valuemin="0" aria-valuemax="100"
                                    style={{ width: `${this.state.strengPass}%`}}
                                >
                                    <span className="progress-text color-black text-center">Độ mạnh của mật khẩu: {this.state.strengPass}%</span>
                                </div>
                            )
                        }
                    </div>
                </>
            )
        }
        else if ( action === 'change_domain' ) {
            return (
                <div className="form-group">
                    <label htmlFor="domain">Domain mới</label>
                    <input type="text" className="form-control" value={ this.state.domain }
                           name="domain" onChange={ this.changeInput }
                    />
                </div>
            )
        }
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            }
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            action: this.state.action,
            domain: this.state.domain,
            password: this.state.password,
            hostingId: this.props.hostingId,
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/hosting/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error > 9000 ) {
                    this.props.logOut();
                }
                else if ( ref.data.error ) {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title,
                            isSpinner: false,
                        },
                    })
                }
                else {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title,
                            isSpinner: false,
                        },
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    confirmHosting = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            }
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            action: this.state.action,
            hostingId: this.props.hostingId,
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/hosting/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error > 9000 ) {
                    this.props.logOut();
                }
                else if ( ref.data.error ) {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title,
                            isSpinner: false,
                        },
                    })
                }
                else {
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title,
                            isSpinner: false,
                        },
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    changePassword = (event) => {
        let password = event.target.value;
        let strengPass = this.passwordChanged(password);
        this.setState({
            changeDomain: password,
            strengPass: strengPass
        });

        let titleModal = 'Đổi mật khẩu';
        let modalBody = this.modalBody('change_password');
        this.setState({
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
        })
    }

    //kiểm tra mật khẩu
    passwordChanged = (pass) => {
        var  symbolSize = 0, natLog, score;
        var format = /[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/;

        if ( pass.match(/[0-9]/) ) {
            symbolSize +=20;
        }
        if ( pass.match(/[a-z]/) ) {
            symbolSize +=28;
        }
        if ( pass.match(/[A-Z]/) ) {
            symbolSize +=28;
        }
        if ( format.test(pass) ) {
            symbolSize +=35;
        }
        if ( pass.match(/[^a-zA-Z0-9]/) ) {
            symbolSize +=35;
        }

        natLog = Math.log( Math.pow(symbolSize, pass.length) );
        score = natLog / Math.LN2;
        return parseInt(score);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Chi tiết Hosting"} page={"Hosting"} icon={<FaDatabase className="breadcrumb-icon"/>} />
                            {
                                this.state.errorNotification ? (

                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageErrorNotification }
                                        </div>
                                    </Alert>
                                ) : (
                                    <></>
                                )
                            }
                            <Card>
                                <CardHeader>
                                    <h3 className="card-title">Thông tin dịch vụ / sản phẩm</h3>
                                </CardHeader>
                                <CardBody className="row product-details clearfix">
                                    <div className="col-md-6 mb-4">
                                        <div className={ "product-status product-status-" + this.state.hosting.status_hosting }>
                                            <div className="product-icon text-center">
                                                <span className="fa-stack fa-lg">
                                                    <FaCircle className="fa-stack-2x" />
                                                    <FaServer className="fa-stack-1x fa-inverse" />
                                                </span>
                                                <h3>{ this.state.hosting.product_name }</h3>
                                                <h4>Cloud Hosting</h4>
                                            </div>
                                            <div className="product-status-text">
                                                { this.state.hosting.text_status_hosting }
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            {
                                                this.state.hosting.status_hosting === 'on' || this.state.hosting.status_hosting === 'off' ||
                                                this.state.hosting.status_hosting === 'expire' ? (
                                                    <>
                                                        <div className="col-md-12 max-with-70">
                                                            <button type="button" className="btn btn-block btn-danger">Hủy dịch vụ</button>
                                                        </div>
                                                        <div className="col-md-12 max-with-70 mt-1">
                                                            <button type="button" className="btn btn-block btn-success">Gia hạn dịch vụ</button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-6 text-center info-services">
                                        <Table className="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Ngày tạo</td>
                                                    <td>{ this.state.hosting.text_created_at }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Chi phí</td>
                                                    <td>{ this.state.hosting.text_amount } ₫</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Thời gian thuê</td>
                                                    <td>{ this.state.hosting.text_billing_cycle }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Ngày hết hạn</td>
                                                    <td>{ this.state.hosting.text_next_due_date }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Hình thức thanh toán</td>
                                                    <td>Thanh toán bằng số dư tài khoản</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Table className="table table-sm table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td className="text-left font-weight-bold text-center" colSpan={2}>Thông tin chi tiết hosting</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">IP Address</td>
                                                    <td>{ this.state.hosting.server_hosting_ip }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Url</td>
                                                    <td>{ this.state.hosting.server_hosting_url } </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Domain</td>
                                                    <td>{ this.state.hosting.domain }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Username</td>
                                                    <td>{ this.state.hosting.username }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left font-weight-bold">Password</td>
                                                    <td>{ this.state.hosting.password }</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                            {
                                this.state.hosting.status_hosting === 'on' || this.state.hosting.status_hosting === 'off' ? (
                                    <Card className="mt-4">
                                        <CardHeader>
                                            <h3 className="card-title">
                                                Quick Shortcuts
                                            </h3>
                                        </CardHeader>
                                        <CardBody className="row mb-4">
                                            <div className="row">
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('login_to') }>
                                                        <div className="quick-image">
                                                            <img src={LoginToImg} alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Đăng nhập đến cPanel
                                                        </div>
                                                    </span>
                                                </div>
                                                {
                                                    this.state.hosting.check_update ? (
                                                        <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                            <Link to={'/dat-hang/hosting/' + this.state.hosting.id + '/nang-cap-dich-vu.html'}  className="text-center">
                                                                <div className="quick-image">
                                                                    <img src={UpgradeImg}
                                                                         alt="icon-quick" />
                                                                </div>
                                                                <div className="quick-text">
                                                                    Nâng cấp dịch vụ
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span  className="text-center" onClick={ () => this.actionHosting('change_password') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={ChangePassImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Đổi mật khẩu
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('change_domain') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={ChangeDomainImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Thay đổi domain
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('file_manager') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={FileManageImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            File Manager
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('mysql_databases') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={SqlImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            MySQL Databases
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('backup') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={BackupImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Backup
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('subdomains') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={SubDomainImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Subdomain
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('addon_domains') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={AddonDomain}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Addon Domain
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('cron_jobs') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={CronJobImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            CronJob
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('php_my_admin') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={PhpMyAdminImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Phpmyadmin
                                                        </div>
                                                    </span>
                                                </div>
                                                <div className="col-4 col-md-3 col-lg-2 mb-4 quick-row">
                                                    <span className="text-center" onClick={ () => this.actionHosting('awstats') }>
                                                        <div className="quick-image">
                                                            <img
                                                                src={AwstatsImg}
                                                                alt="icon-quick" />
                                                        </div>
                                                        <div className="quick-text">
                                                            Awstats
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                ) : (
                                    <></>
                                )
                            }
                            {/*<Card className="mt-4">*/}
                            {/*    <CardHeader>*/}
                            {/*        <h3 className="card-title">*/}
                            {/*            Thông tin hoạt động*/}
                            {/*        </h3>*/}
                            {/*    </CardHeader>*/}
                            {/*    <CardBody className="row mb-4">*/}
                            {/*        <Table className="table table-sm table-bordered table-hover rounded text-center">*/}
                            {/*            <thead>*/}
                            {/*                <tr>*/}
                            {/*                    <td>Hành động</td>*/}
                            {/*                    <td>Trạng thái</td>*/}
                            {/*                    <td>Thời gian</td>*/}
                            {/*                </tr>*/}
                            {/*            </thead>*/}
                            {/*            <tbody>*/}
                            {/*                { this.loadLogActivity() }*/}
                            {/*            </tbody>*/}
                            {/*        </Table>*/}
                            {/*    </CardBody>*/}
                            {/*</Card>*/}
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerDetailHosting' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DetailHostingComponent);